import { defineNuxtPlugin, useRouter } from "#app";
import { useAnalytics } from "~/composables/useAnalytics";

function resolvePageName(path: string, matchedName?: string): string {
  if (path === "/") return "Homepage";
  if (path.startsWith("/artworks/sets/")) return "Artwork Set Detail";
  if (path.startsWith("/artworks/")) return "Artwork Detail";
  if (path === "/artworks") return "Artworks Catalogue";
  if (path.startsWith("/artists/")) return "Artist Detail";
  if (path === "/artists") return "Artists Catalogue";
  if (path.startsWith("/constellations/")) return "Constellation Detail";
  if (path === "/constellations") return "Constellations";
  if (path.startsWith("/selections/")) return "Selection Detail";
  if (path === "/selections") return "Selections";
  if (path === "/the-movement") return "The Movement";
  if (path === "/privacy-policy") return "Privacy Policy";
  if (path === "/terms") return "Terms";
  if (path === "/orders") return "Orders";
  if (path === "/profile") return "Profile";
  if (path === "/signin") return "Sign In";
  if (path === "/signup") return "Sign Up";
  if (path === "/contact-us") return "Contact Us";
  return matchedName || path;
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const { setViewInstanceId, trackPageView, getCardAttribution } = useAnalytics();

  let isFirstLoad = true;
  let landingPage = "";
  let landingReferrer = "";

  if (typeof window !== "undefined") {
    landingPage = window.location.href;
    landingReferrer = document.referrer || "";

    // 1. Capture UTM parameters
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentUtm: Record<string, string> = {};
      const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
      for (const key of utmKeys) {
        const val = urlParams.get(key);
        if (val) currentUtm[key] = val;
      }

      if (Object.keys(currentUtm).length > 0) {
        // First-touch
        if (!sessionStorage.getItem("qam_first_touch_utm")) {
          sessionStorage.setItem("qam_first_touch_utm", JSON.stringify({
            ...currentUtm,
            landing_page: landingPage,
            referrer: landingReferrer,
          }));
        }
        // Last-touch
        sessionStorage.setItem("qam_last_touch_utm", JSON.stringify({
          ...currentUtm,
          landing_page: landingPage,
          referrer: landingReferrer,
        }));
      }
    } catch (_) {}
  }

  const handleRouteView = (to: any, from?: any) => {
    const viewInstanceId = setViewInstanceId();
    const pageName = resolvePageName(to.path, typeof to.name === "string" ? to.name : undefined);
    const attr = getCardAttribution();
    const entryExposureId = attr?.exposure_id;

    trackPageView({
      page_name: pageName,
      route_template: to.matched?.[0]?.path || to.path,
      path: to.fullPath || to.path,
      referrer: from?.fullPath ? window.location.origin + from.fullPath : landingReferrer,
      landing_page: landingPage,
      view_instance_id: viewInstanceId,
      entry_exposure_id: entryExposureId,
    });
  };

  // Initial page load
  nuxtApp.hook("app:mounted", () => {
    if (isFirstLoad) {
      isFirstLoad = false;
      handleRouteView(router.currentRoute.value);
    }
  });

  // Client-side SPA navigation
  router.afterEach((to, from) => {
    if (!isFirstLoad && to.fullPath !== from.fullPath) {
      handleRouteView(to, from);
    }
  });
});
